import { format } from 'date-fns';

export function formatDate(date: string, $format: string) {
  const $date = new Date(date);
  return format($date, $format);
}
